import { Search, ShoppingCartOutlined } from "@mui/icons-material";
import { Badge, IconButton } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { HOSTNAME } from "../Utils/defaults";


const Universalheader = ({ onshowsearchbar }) => {
    const navigate = useNavigate()
    const cartItems = useSelector(state => state.cartItems.data);



    return (
        <div className="pageheader">
            <div className="headersearchdiv" onClick={() => onshowsearchbar()}>
                <IconButton>
                    <Search />
                </IconButton>
                <div className="searchtext">Search on {HOSTNAME}</div>
            </div>
            <div >
                <IconButton onClick={() => navigate("/cart")}>
                    {cartItems?.length > 0 ?
                        <Badge badgeContent={cartItems?.length} color="primary" >
                            <ShoppingCartOutlined color="secondary" />
                        </Badge> :
                        <ShoppingCartOutlined color="secondary" />
                    }
                </IconButton>
            </div>
        </div>
    )
}

export default Universalheader;